import React, {useState, useEffect, useContext} from "react";
import "./Hackathon.scss";
import {hackathonSection} from "../../portfolio";
import {Fade} from "react-reveal";
import StyleContext from "../../contexts/StyleContext";

export default function Hackathon() {
  const {isDark} = useContext(StyleContext);
  const [currentHackathonIndex, setCurrentHackathonIndex] = useState(0);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const currentHackathon = hackathonSection.hackathons[currentHackathonIndex];
  const currentImages = currentHackathon?.images || [];

  useEffect(() => {
    if (currentImages.length === 0) return;

    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) => {
        if (prevIndex < currentImages.length - 1) {
          return prevIndex + 1;
        } else {
          // Loop back to first image
          return 0;
        }
      });
    }, hackathonSection.slideInterval || 3000);

    return () => clearInterval(interval);
  }, [currentImages.length, currentHackathonIndex]);

  // Reset image index when hackathon changes
  useEffect(() => {
    setCurrentImageIndex(0);
  }, [currentHackathonIndex]);

  if (!hackathonSection.display) {
    return null;
  }

  const handleHackathonClick = (index) => {
    setCurrentHackathonIndex(index);
    setCurrentImageIndex(0);
  };

  function openUrlInNewTab(url) {
    if (!url) {
      return;
    }
    var win = window.open(url, "_blank");
    win.focus();
  }

  return (
    <Fade bottom duration={500} distance="10px">
      <div className="main" id="hackathon">
        <div className="hackathon-main-div">
          <div className="hackathon-header">
            <h1
              className={
                isDark
                  ? "dark-mode heading hackathon-heading"
                  : "heading hackathon-heading"
              }
            >
              {hackathonSection.title}
            </h1>
          </div>

          {/* Hackathon Cards */}
          <div className="hackathon-cards">
            {hackathonSection.hackathons.map((hackathon, index) => (
              <div
                key={index}
                className={`hackathon-card ${
                  currentHackathonIndex === index ? "active" : ""
                } ${isDark ? "dark-mode" : ""}`}
                onClick={() => handleHackathonClick(index)}
              >
                <h3 className="hackathon-card-title">{hackathon.name}</h3>
                <p className="hackathon-card-subtitle">{hackathon.description}</p>
              </div>
            ))}
          </div>

          {/* Slideshow Container */}
          {currentHackathon && (
            <div className="hackathon-content">
              {currentImages.length > 0 ? (
                <div className="hackathon-slideshow">
                  <div className="hackathon-image-container">
                    <img
                      src={currentImages[currentImageIndex]}
                      alt={`${currentHackathon.name} - ${currentImageIndex + 1}`}
                      className="hackathon-image"
                    />
                  </div>
                  <div className="hackathon-slideshow-controls">
                    <div className="hackathon-indicators">
                      {currentImages.map((_, index) => (
                        <span
                          key={index}
                          className={`indicator ${
                            currentImageIndex === index ? "active" : ""
                          }`}
                          onClick={() => setCurrentImageIndex(index)}
                        />
                      ))}
                    </div>
                    <div className="hackathon-info">
                      <span className="image-counter">
                        {currentImageIndex + 1} / {currentImages.length}
                      </span>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="hackathon-placeholder">
                  <p>Images will be added soon...</p>
                </div>
              )}

              {/* LinkedIn Link Button */}
              {currentHackathon.linkedInLink && (
                <div className="hackathon-link-div">
                  <button
                    className={`hackathon-link-button ${isDark ? "dark-mode" : ""}`}
                    onClick={() => openUrlInNewTab(currentHackathon.linkedInLink)}
                  >
                    View on LinkedIn
                  </button>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </Fade>
  );
}

